import { render, staticRenderFns } from "./OriginAndDestination.vue?vue&type=template&id=5041d68c&scoped=true"
import script from "./OriginAndDestination.vue?vue&type=script&lang=js"
export * from "./OriginAndDestination.vue?vue&type=script&lang=js"
import style0 from "./OriginAndDestination.vue?vue&type=style&index=0&id=5041d68c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5041d68c",
  null
  
)

export default component.exports